import { Link, useNavigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { useEffect } from 'react';
import { usePinSession } from '@/lib/auth/pin/usePinSession';

/**
 * Tier-2 lock screen. The big primary button starts the PIN flow; the small
 * secondary link triggers MSAL Manager SSO. If either tier is already
 * authenticated we forward to /dashboard.
 */
export function KioskLock() {
  const navigate = useNavigate();
  const isMsalAuth = useIsAuthenticated();
  const { session: pinSession } = usePinSession();

  useEffect(() => {
    if (isMsalAuth || pinSession) {
      navigate('/dashboard', { replace: true });
    }
  }, [isMsalAuth, pinSession, navigate]);

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center gap-8 p-6 bg-gradient-to-b from-brand-navy to-brand-navy-deep">
      <img
        src="/brand/qargo-white-tagline.png"
        alt="Qargo Coffee — Italy's finest coffee &amp; pastries"
        className="w-56 max-w-full"
      />
      <p className="text-brand-beige/90 text-sm font-medium tracking-[0.3em] uppercase -mt-2">
        Qargo IMS
      </p>
      <Link
        to="/kiosk/username"
        className="w-72 h-16 rounded-xl bg-brand-beige text-brand-navy text-lg font-semibold shadow-lg hover:opacity-90 flex items-center justify-center"
      >
        Start shift
      </Link>
      <Link
        to="/signin"
        className="text-sm text-brand-beige/70 underline underline-offset-4 hover:text-brand-beige"
      >
        Manager sign-in (SSO)
      </Link>
      <img src="/brand/tmkn-white.png" alt="TMKN" className="h-6 opacity-60 absolute bottom-8" />
    </div>
  );
}
